/*
 * File: RecentPatientActions.js
 * Project: mp-mobile-app
 *
 * Created by Jed Dumire on 12/19/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Utility object to handle updating recent patients, as well as getting the list formatted for display.
 */
import { Instance } from "mobx-state-tree";
import Preferences from "services/preferences/Store";
import PatientModel from "../demographics/patient_info/store/DemographicsModel";

const RecentPatientActions = {
  selectPatient(
    selectedPatient: Instance<typeof PatientModel>,
    preferencesStore: Instance<typeof Preferences>
  ) {
    return this.updatePatient(selectedPatient, preferencesStore);
  },

  async updatePatient(
    editPatient: Instance<typeof PatientModel>,
    store: Instance<typeof Preferences>
  ) {
    if (editPatient.patientId !== undefined) {
      await store.apply("recentPatients", editPatient.patientId);
    }
  },
  uiLinks(store: Instance<typeof Preferences>) {
    return store.get("recentPatients").map(patient => ({
      url: `/patients/${patient.patientId}/patient_home`,
      primaryString: `${patient.patientName()} (${patient.displayId})`
    }));
  }
};

export default RecentPatientActions;
